import React from 'react';

import { Segmented, Switch } from 'antd';

import {
    usePlaylistEditor,
    usePlaylistEditorDispatch,
} from './PlaylistEditorContext';

const PicturesArchiveHeader = () => {
    const { mediaTypeToDisplay, hideUsedPictures, extendedFilters } =
        usePlaylistEditor();
    const dispatch = usePlaylistEditorDispatch();

    const handleMediaTypeChange = (value) => {
        dispatch({
            type: 'ChangeMediaTypeToDisplay',
            value,
        });
    };

    const handleHideUsedPicturesChange = (value) => {
        dispatch({
            type: 'ToggleHideUsedPictures',
            value,
        });
    };

    const handleExtendedFiltersChange = (value) => {
        dispatch({
            type: 'ToggleExtendedFilters',
            value,
        });
    };

    return (
        <div className="archive-header">
            <div className="archive-header-control">
                <Segmented
                    size="small"
                    options={[
                        { label: 'Pictures', value: 'Photo' },
                        { label: 'Videos', value: 'Video' },
                    ]}
                    value={mediaTypeToDisplay}
                    onChange={handleMediaTypeChange}
                />
            </div>
            <div className="archive-header-control">
                <Segmented
                    size="small"
                    options={[
                        { label: 'Fade', value: false },
                        { label: 'Hide', value: true },
                    ]}
                    value={hideUsedPictures}
                    onChange={handleHideUsedPicturesChange}
                />
                <span>Used items</span>
            </div>
            {/* add a switch to toggle the extended filters */}
            {/* <Switch
                checked={extendedFilters}
                onChange={handleExtendedFiltersChange}
            /> */}
        </div>
    );
};

export default PicturesArchiveHeader;
